export default {
    name: "Citrix Secure Workspace",
    currency: "USD",
    editions: {
        "Secure Private Access Standard": {
            rate: 3,
            tiers: {
                "1-100": 48,
                "101-250": 40,
                "251-1000": 30,
                "1001-2500" : 30
            }
        },
        "Secure Private Access Advanced": {
            rate: 7,
            tiers: {
                "1-100": 100,
                "101-250": 80,
                "251-1000": 65,
                "1001-2500" : 55
            }
        }
    },  
    formatNumber: function(num){
        return "$"+num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getCost: function(edition, users, discount, term){
        if(isNaN(users)){
            return 0
        }
        if(this.editions.hasOwnProperty(edition)) {
            let percentage = (100 - discount) / 100
            let cost = 0,
                _edition = this.editions[edition]
            let tiers = Object.keys(_edition.tiers)
            for (const tier of tiers) {
                let range = tier.split("-").map(function(num){
                    return parseInt(num)
                }), max = 0
                if(range[0] <= users && users <= range[1]){
                    max = users
                }else if(users > range[1]){
                    max = range[1]
                }else{
                    break
                }
                cost += _edition.tiers[tier]*((max+1) - range[0])
            }
            //cost = (((cost*percentage)*term)/(12*term)).toFixed(2)
            cost = (((cost*percentage)*term)/(12*term)/users).toFixed(2)
            return this.formatNumber(cost)

        }
    }
}